module.exports = __webpack_public_path__ + "img/2.a81d2024.jpg";